<template>
  <div>
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <div
      class="fixed top-0 left-0 z-[9999] w-full h-full md:hidden"
      :class="{
        'pointer-events-none': !pannelIsVisible,
      }"
      v-if="userData?.email"
    >
      <Tabs
        v-slot="{ data }"
        :nbTabs="2"
        :defaultTab="0"
        :allowTouchMove="true"
        ref="tabsContainer"
        @tabChanged="
          index => {
            onTabChanged(index)
          }
        "
      >
        <div class="h-full" v-if="data.position == 1">
          <div class="absolute w-full h-full translate-x-full bg-white"></div>
          <div
            class="absolute w-4/5 h-full left-0 bg-black bg-opacity-50 duration-300"
            @click="hidePannel"
          ></div>
          <div
            :class="{
              'pointer-events-none opacity-0 ': !pannelIsVisible,
            }"
            class="absolute w-full h-full bg-black bg-opacity-50 duration-300 -translate-x-full"
          ></div>
          <div
            class="left-[20vw] w-[80vw] bg-white h-full relative duration-300"
            :class="{
              '-translate-x-[20vw]': !pannelIsVisible,
            }"
          >
            <div
              class="w-[5.5svh] top-[2svh] bg-white p-4 border-r-transparent rounded-l-full h-[5.5svh] absolute right-full !pointer-events-auto"
              @click="
                () => {
                  if (pannelIsVisible) hidePannel()
                  else openPannel()
                }
              "
              :class="{
                'opacity-0': pannelIsVisible,
              }"
            >
              <img
                src="@/assets/images/all/menu.svg"
                class="w-full h-full object-contain"
                alt=""
                :class="{}"
              />
            </div>
            <MenuPannelContent @navClicked="hidePannel" />
          </div>
        </div>
      </Tabs>
    </div>

    <div
      class="top-0 left-0 z-10 h-full hidden md:block overflow-hidden duration-300"
      :class="{
        'w-[18.5rem]':
          userData?.email && !pannelCollapsed && !needPlatformAccessPayment,
        'w-[6rem]':
          userData?.email && (pannelCollapsed || needPlatformAccessPayment),
        '!w-0': !userData?.email,
      }"
    >
      <div
        class="h-full relative w-full"
        @mouseenter="
          () => {
            pannelCollapsed = false
          }
        "
        @mouseleave="
          () => {
            pannelCollapsed = true
          }
        "
      >
        <!-- <div
          class="cursor-pointer w-[2.5rem] h-[2.5rem] top-[3.8rem] z-[2] bg-white p-2 border-r-transparent rounded-l-full absolute right-[10px]"
          @click="togglePannelCollapse()"
          v-if="!needPlatformAccessPayment"
        >
          <img
            src="@/assets/images/icons/previous.svg"
            class="w-full h-full object-contain duration-300"
            alt=""
            :class="{ 'rotate-180': pannelCollapsed }"
          />
        </div> -->
        <div class="h-full min-h-max border-r">
          <MenuPannelContent
            :pannelCollapsed="pannelCollapsed || needPlatformAccessPayment"
            @navClicked="() => {}"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Tabs from '@/components/utils/Tabs.vue'
import MenuPannelContent from '@/components/appComponent/MenuPannelContent.vue'
import UserProperty from '@/components/user/UserProperty.vue'
import ScrollComponent from '../utils/ScrollComponent.vue'

export default defineComponent({
  name: 'MenuPannel',
  components: { Tabs, MenuPannelContent, ScrollComponent, UserProperty },
  props: { needPlatformAccessPayment: { type: Boolean, default: false } },
  data() {
    return {
      eventsIds: [],
      pannelIsVisible: false,
      pannelCollapsed: true,
      userData: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('open_sidebar_menu', this.openPannel)
    const id2 = this.$Events.handleEvent('logout_done', () => {
      this.userData = {}
    })
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  methods: {
    togglePannelCollapse() {
      this.pannelCollapsed = !this.pannelCollapsed
    },
    openPannel() {
      this.$refs.tabsContainer?.slideTo(1)
    },
    onTabChanged(index) {
      if (index == 1) this.pannelIsVisible = true
      else
        setTimeout(() => {
          this.pannelIsVisible = false
        }, 300)
    },
    hidePannel() {
      this.$refs.tabsContainer?.slideTo(0)
    },
  },
  watch: {},
})
</script>
